import { alloy } from './alloy-loader';

/**
 * Send an analytics event to Adobe Experience Platform
 * 
 * @param {string} eventId - The Adobe Analytics event ID (e.g., 'event4', 'event10')
 * @param {Object} props - The props object for custom dimensions
 *                         Keys should be prop IDs from variableMap (e.g., 'prop6', 'prop8')
 *                         Values should be strings
 * @returns {Promise<void>}
 * 
 * @example
 */
export async function hitEvent(eventId, props = {}) {
  try {
    const alloyInstance = alloy();

    const xdmPayload = {
      xdm: {
        _experience: {
          analytics: {
            event1to100: {
              [eventId]: {
                id: eventId,
                value: 1,
              },
            },
            customDimensions: {
              props,
            },
          },
        },
      },
    };

    await alloyInstance('sendEvent', xdmPayload);

    if (process.env.NODE_ENV === 'development') {
      console.log('Analytics event sent:', {
        eventId,
        props,
      });
    }
  } catch (error) {
    console.error('Failed to send analytics event:', error);
  }
}
